import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]

  connect() {
    console.log("Mission form controller connected")
  }

  submit(event) {
    event.preventDefault()
    
    const formData = new FormData(event.target)
    const jsonData = this.formDataToJson(formData)
    
    this.outputTarget.value = JSON.stringify(jsonData, null, 2)
    console.log('Generated Mission:', jsonData)
  }

  formDataToJson(formData) {
    const json = {
      mission: {
        title: formData.get('mission[title]'),
        description: formData.get('mission[description]'),
        objectives: this.getObjectives(formData),
        layout_features: this.getLayoutFeatures(formData)
      },
      mission_template: {
        template_name: formData.get('mission_template[template_name]'),
        description: formData.get('mission_template[description]'),
        default_objectives: this.getDefaultObjectives(formData),
        default_layout_features: this.getDefaultLayoutFeatures(formData)
      }
    }
    return json
  }

  // Helper methods to collect array data
  getObjectives(formData) {
    return this.getArrayData(formData, 'mission[objectives]')
  }

  getLayoutFeatures(formData) {
    return this.getArrayData(formData, 'mission[layout_features]')
  }

  getDefaultObjectives(formData) {
    return this.getArrayData(formData, 'mission_template[default_objectives]')
  }

  getDefaultLayoutFeatures(formData) {
    return this.getArrayData(formData, 'mission_template[default_layout_features]')
  }

  getArrayData(formData, prefix) {
    const array = []
    let index = 0
    
    while (formData.has(`${prefix}[${index}][title]`)) {
      const item = {}
      for (const [key, value] of formData.entries()) {
        if (key.startsWith(`${prefix}[${index}]`)) {
          const property = key.match(/\[([^\]]+)\]$/)[1]
          item[property] = value
        }
      }
      array.push(item)
      index++
    }
    
    return array
  }
} 